import Reveal from "@/components/Reveal";
import { Check, Minus } from "lucide-react";

const rows = [
  ["ADAC schema awareness", true, false, "partial"],
  ["Create compliant XML", true, false, false],
  ["Validate submissions", true, "partial", true],
  ["Compare versions", true, false, false],
  ["Data quality profiling", true, false, false],
  ["Consistent acceptance standard", true, false, false],
  ["Audit-ready reports", true, false, "partial"],
];

const cols = ["WebADAC", "Generic XML tools", "Manual scripts", "Validator-only tools"];

function Cell({ v }) {
  if (v === true) return <Check size={18} className="mx-auto text-[#16A34A]" />;
  if (v === "partial") return <Minus size={18} className="mx-auto text-amber-500" />;
  return <Minus size={18} className="mx-auto text-zinc-300" />;
}

export default function Competitive() {
  return (
    <section data-testid="competitive-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="max-w-3xl mb-14">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0033A0] font-mono">Why not generic tools?</p>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-medium tracking-tight text-zinc-900 leading-tight">
            Built specifically for ADAC — not adapted from a generic XML editor.
          </h2>
        </Reveal>

        <Reveal className="overflow-x-auto rounded-2xl border border-zinc-200 bg-white">
          <table data-testid="competitive-table" className="w-full text-sm min-w-[640px]">
            <thead>
              <tr className="border-b border-zinc-200">
                <th className="text-left font-heading font-medium text-zinc-900 p-5">Capability</th>
                {cols.map((c, i) => (
                  <th
                    key={c}
                    className={`p-5 text-center font-heading font-medium ${
                      i === 0 ? "text-[#0033A0] bg-[#E6EBF5]/50" : "text-zinc-600"
                    }`}
                  >
                    {c}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, ri) => (
                <tr key={ri} className="border-b border-zinc-100 last:border-0">
                  <td className="p-5 text-zinc-700">{r[0]}</td>
                  <td className="p-5 bg-[#E6EBF5]/30"><Cell v={r[1]} /></td>
                  <td className="p-5"><Cell v={r[2]} /></td>
                  <td className="p-5"><Cell v={r[3]} /></td>
                  <td className="p-5"><Cell v={r[4]} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </Reveal>
        <p className="mt-4 text-xs text-zinc-500 font-mono">
          <Check size={12} className="inline text-[#16A34A]" /> full &nbsp;
          <Minus size={12} className="inline text-amber-500" /> partial &nbsp;
          <Minus size={12} className="inline text-zinc-300" /> not supported
        </p>
      </div>
    </section>
  );
}
